module.exports = __webpack_public_path__ + "e61e8f848b6c596c738c533d4a05b6ed.MP3";